import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiStripepaymentgatewayPaymentIntentDetailQueryResponse,
  GetApiStripepaymentgatewayPaymentIntentDetailQueryParams,
  GetApiStripepaymentgatewayPaymentIntentDetail401,
  GetApiStripepaymentgatewayPaymentIntentDetail403,
} from "../../../types/GetApiStripepaymentgatewayPaymentIntentDetail";

export function getGetApiStripepaymentgatewayPaymentIntentDetailUrl() {
  return `/api/StripePaymentGateway/payment-intent-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/payment-intent-detail}
 */
export async function getApiStripepaymentgatewayPaymentIntentDetail(
  params?: GetApiStripepaymentgatewayPaymentIntentDetailQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiStripepaymentgatewayPaymentIntentDetailQueryResponse,
    ResponseErrorConfig<
      | GetApiStripepaymentgatewayPaymentIntentDetail401
      | GetApiStripepaymentgatewayPaymentIntentDetail403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiStripepaymentgatewayPaymentIntentDetailUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
